let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3V2y8")).then(() => parcelRequire('e88pi'));